const LS = {
  LAST_SESSION_PROVIDER: 'lastSessionProvider',
  LAST_SESSION: 'lastSession',
  PRODUCT_CREATE_DATA: 'productCreateData',
  PRODUCT_EDIT_DATA: 'productEditData',
  SESSIONS: 'sessions',
  INGREDIENT_ID: 'ingredientId',
  SEARCH_ITEM_ID: 'searchItemId',
  GDPR: 'gdpr'
}

export default LS
